/**
 * Helper: Format image URL
 * -----------------------------------------------------------------------------
 * See scripts/helpers/format.js for arguments.
 *
 * @returns {String}
 *
 */
import { formatImageUrl } from '~/helpers/format'

export default (src, options) => {
  return formatImageUrl(src, options)
}
